var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 52,
    fill: "none",
    viewBox: "0 0 50 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M3 8.62183L13.8106 32.0001C15.6288 29.7534 18.1062 28.0617 20.946 27.2215L12.7676 8.62183H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M38.6703 8.62183L29.6919 27.2215C32.5317 28.0617 35.0091 29.7534 36.8273 32.0001L47.8655 8.63576L38.6703 8.62183Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    fillRule: "evenodd",
    d: "M14 40.5C14 34.1589 19.159 29 25.5 29C31.841 29 37 34.1588 37 40.5C37 46.8411 31.841 52 25.5 52C19.159 52 14 46.8412 14 40.5ZM27.5068 37.3321L25.4602 33.5L23.4136 37.3306C23.272 37.6343 22.8965 37.9229 22.5793 37.9715L18.5 38.8469L21.3146 42.0892C21.5441 42.3254 21.6874 42.7924 21.6332 43.1262L21.1587 47.4985L24.9443 45.6703C25.228 45.5126 25.692 45.5126 25.9757 45.6703L29.7616 47.5L29.2871 43.1278C29.2329 42.7939 29.3762 42.3273 29.6058 42.0907L32.5 38.8484L28.341 37.9731C28.0241 37.9244 27.6486 37.6358 27.5068 37.3321Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M11.7676 0.621826H26.2832H39.6705L43.7832 6.62183H6.7832L11.7676 0.621826Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.9179ea1082f8c3f3e3bebf69f20df248.svg";
export { ForwardRef as ReactComponent };